import React, { useState, useEffect } from "react";
import logo from "../../assets/house-icon-logo.png";
import plus_icon from "../../assets/plus_icon.png";
import message_icon from "../../assets/message_icon.png";
import { Link } from "react-router-dom";
import styles from "./NavBar.module.css";
import home_icon from "../../assets/navbar-home.png";
import settings_icon from "../../assets/settings-icon.png";
import notif_icon from "../../assets/notificationWhite.png";
import saved_icon from "../../assets/saved_icon.png";

const API_BASE_URL = "https://weatherbuddy.org/HomeMate/backend/"; //update to global base_url

export default function NavBar() {
    // Existing notification count
    const [notificationCount, setNotificationCount] = useState(0);
    // NEW: track if there are any unread messages
    const [hasUnreadMessages, setHasUnreadMessages] = useState(false);

    useEffect(() => {
        let alive = true;

        const fetchCounts = async () => {
            try {
                // Fetch notifications and conversations in parallel
                const notifPromise = fetch(`${API_BASE_URL}get_notification_count.php`, {
                    credentials: "include",
                });

                const messagesPromise = fetch(
                    `${API_BASE_URL}messages/list_conversations.php`,
                    { credentials: "include" }
                );

                const [notifRes, msgRes] = await Promise.all([notifPromise, messagesPromise]);

                // --- Notifications ---
                if (notifRes.ok) {
                    const data = await notifRes.json();
                    if (alive) {
                        if (data && typeof data.count === "number") {
                            setNotificationCount(data.count);
                        } else if (data && data.error) {
                            console.error("Backend Error fetching notification count:", data.error);
                            setNotificationCount(0);
                        } else {
                            setNotificationCount(0);
                        }
                    }
                } else {
                    console.error("HTTP error fetching notification count:", notifRes.status);
                    if (alive) setNotificationCount(0);
                }

                // --- Unread messages ---
                if (msgRes.ok) {
                    const msgData = await msgRes.json();
                    const hasUnread =
                        Array.isArray(msgData.conversations) &&
                        msgData.conversations.some((c) => c.is_unread);

                    if (alive) {
                        setHasUnreadMessages(hasUnread);
                    }
                } else {
                    console.error("HTTP error fetching conversations:", msgRes.status);
                    if (alive) setHasUnreadMessages(false);
                }
            } catch (error) {
                console.error("Failed to fetch notification/message counts:", error);
                if (alive) {
                    setNotificationCount(0);
                    setHasUnreadMessages(false);
                }
            }
        };

        // Initial fetch
        fetchCounts();

        // Poll every 30 seconds (same idea as notifications)
        const intervalId = setInterval(fetchCounts, 30000);

        return () => {
            alive = false;
            clearInterval(intervalId);
        };
    }, []);

    const wrap = {
        position: "sticky",
        top: 0,
        zIndex: 100,
        background: "#EE3F3C", // Login red
        color: "#fff",
        boxShadow: "0 1px 0 rgba(0,0,0,.08)",
    };

    const brandText = { fontWeight: 800, fontSize: 28, letterSpacing: ".3px" };

    const nav = {
        display: "flex",
        alignItems: "center",
        marginRight: "10px"
    };
    const link = { color: "#fff", textDecoration: "none", fontSize: 18 };
    const iconBtn = {
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
    };

    return (
        <header style={wrap} className={styles.headerWrap}>
            <div className={styles.brand}>
                <img src={logo} alt="HomeMate logo" width="40" height="40" />
                <span style={brandText}>HomeMate</span>
            </div>

            <nav className={`${styles.nav} ${styles.navbarLinks}`}>
                <Link to="/home" style={link} className={styles.navText}>Homepage</Link>

                <span className={styles.navShowIcon}>
                    <Link to="/home" style={iconBtn}>
                        <img className={styles.homeLinkIcon} alt="Go Home" height="28" width="28" src={home_icon} />
                    </Link>
                </span>

                <Link to="/settings" style={link} className={styles.navText}>Settings</Link>

                <Link to="/saved" style={link} className={styles.navText}>Saved</Link>

                <span className={styles.navShowIcon}>
                    <Link to="/settings" style={iconBtn}>
                        <img alt="Settings" height="28" width="28" src={settings_icon} />
                    </Link>
                </span>

                <span className={styles.navShowIcon}>
                    <Link to="/saved" style={iconBtn}>
                        <img alt="Saved" height="28" width="28" src={saved_icon} />
                    </Link>
                </span>

                <Link to="/create-listing" style={iconBtn}>
                    <img alt="Add listing" height="28" width="28" src={plus_icon} />
                </Link>

                {/* Messages icon with unread dot */}
                <Link
                    to="/messages"
                    style={{ ...iconBtn, position: "relative" }}
                    className={styles.messageIconWrap}
                >
                    <img alt="Messages" height="28" width="28" src={message_icon} />
                    {hasUnreadMessages && <span className={styles.unreadMessageDot} />}
                </Link>

                {/* Notifications icon with count badge */}
                <Link to="/notifications" style={{ ...iconBtn, position: "relative" }}>
                    <img alt="view notifications" height="28" width="28" src={notif_icon} />
                    {notificationCount > 0 && (
                        <span className={styles.notificationBadge}>
                            {notificationCount > 99 ? '99+' : notificationCount}
                        </span>
                    )}
                </Link>
            </nav>
        </header>
    );
}
